import React, { useEffect, useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Slider from '@material-ui/core/Slider';
import { styled } from '@material-ui/core/styles';

const marks = [
  {
    value: 0,
    label: 'Progress.',
  },
    {
    value: 100,
    label: '% complete.',
  },
];

//const PrettoSlider = styled(Slider)({
//    height: 15,
//    width: "90%",
//    marginLeft: 20,
//    justify: "center",
//    '& .MuiSlider-thumb': {
//      height: 21,
//      width: 21,
//      backgroundColor: '#fff',
//      border: '2px solid currentColor',
//      marginTop: -9,
//      marginLeft: -9,
//      '&:focus, &:hover, &.Mui-active': {
//        boxShadow: 'inherit',
//      },
//    },
//    '& .MuiSlider-valueLabel': {
//      left: 'calc(-25% + 4px)',
//      scale: (0.01)
//    },
//    '& .MuiSlider-track': {
//      height: 15,
//      borderRadius: 4,
//      opacity: 0.01,
//      
//    },
//    '& .MuiSlider-rail': {
//      height: 15,
//      borderRadius: 4,
//      marginTop: -6,
//      marginLeft: -10,
//      backgroundColor: "#002D55"
//      width: "105%"
//    },
//  });

const PrettoSlider = withStyles({
  root: {
    color: '#FF7F27', // orange
    height: 8,
    minHeight: 8,
    padding: '0 4px',
  },
  thumb: {
    display: 'none', // hide thumb
  },
  track: {
    height: 8,
    borderRadius: 4,
    backgroundColor: '#FF7F27', // orange
  },
  rail: {
    height: 8,
    borderRadius: 4,
    opacity: 0.7,
    backgroundColor: 'rgba(220,220,220,0.7)', // light grey, slightly transparent
  },
  mark: {
    display: 'none', // hide marks
  },
  markActive: {
    display: 'none', // hide active marks
  },
  valueLabel: {
    display: 'none', // hide value label
  },
})(Slider);

function valuetext(value) {
  return `{value} %`;
}

export default function DiscreteSlider(props) {
  const [sliderVal, setSliderVal] = useState(0);

  useEffect(() => {
    if (props.value !== undefined && props.value !== null) {
      setSliderVal(props.value);
    }
  }, [props.value]);

  return (
    <div>
      <PrettoSlider
        defaultValue={0}
        step={1}
        value={sliderVal}
        onChange={(event, value) => {
          setSliderVal(value);
        }}
        disabled
        min={0}
        max={100}
      />
    </div>
  );
}
